import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DocumentEditComponent } from './edit.component';
import { DocumentEditGeneralComponent } from './general/general.component';
import { DocumentEditTemplateComponent } from './template/template.component';
import { DocumentEditSettingsComponent } from './settings/settings.component';
import { DocumentEditSharingSelectionComponent } from './sharing-selection/sharing-selection.component';
import { DocumentEditContentComponent } from './content/content.component';
import { DocumentEditScrollableElementRefDirective } from './scrollable-element-ref/scrollable-element-ref.directive';
import { DocumentEditScrollableElementRefService } from './scrollable-element-ref/scrollable-element-ref.service';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ComponentsModule } from '@fi-app/components/components.module';
import { FiDocumentPanelRootModule } from '../document-panel-root/document-panel-root.module';
import { FiDocumentVersionListModule } from '../version-list/version-list.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiEditPublicationModule } from '@fi-shared/fi-edit-publication/edit-publication.module';
import { DocumentModule } from '../document.module';
import { FiEditNamesMatModule } from '@fi-app/components/fi-edit-names-mat/fi-edit-names-mat.module';
import { FiPageCollapsableContentModule } from '@fi-app/components/fi-page-collapsable-content/fi-page-collapsable-content.module';
import { FiEditorPageModule } from '@fi-app/components/fi-editor-page/fi-editor-page.module';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatCardModule,
        MatCheckboxModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule,
        UtilitiesModule,
        ComponentsModule,
        FiDocumentPanelRootModule,
        FiDocumentVersionListModule,
        FiAppTextSharedModule,
        FiEditPublicationModule,
        DocumentModule,
        FiEditNamesMatModule,
        FiPageCollapsableContentModule,
        FiEditorPageModule,
        FiValidatingFormModule,
        FiPageHeaderModule,
        SelectSearchModule,
        FiErrorMessageModule,
        FiNameInputModule,
    ],
    declarations: [
        DocumentEditComponent,
        DocumentEditGeneralComponent,
        DocumentEditTemplateComponent,
        DocumentEditSettingsComponent,
        DocumentEditSharingSelectionComponent,
        DocumentEditContentComponent,
        DocumentEditScrollableElementRefDirective,
    ],
    exports: [DocumentEditComponent],
    providers: [DocumentEditScrollableElementRefService],
})
export class FiDocumentEditModule {}
